const state = {
    showFbChat: false
  };
  
  export default state;